import React from "react";

const Clubsicon = (props: any) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.56 17.0669C11.2172 17.0669 10.8839 16.9459 10.6218 16.7259L10.6835 16.6524C10.9284 16.8577 11.2397 16.9708 11.56 16.9708C12.3127 16.9708 12.9253 16.3585 12.9253 15.6057C12.9253 14.853 12.3129 14.2404 11.56 14.2404C10.8071 14.2404 10.1947 14.8528 10.1947 15.6057C10.1947 15.7354 10.2128 15.8639 10.2487 15.9872L10.1565 16.014C10.1181 15.8818 10.0986 15.7445 10.0986 15.6057C10.0986 14.8 10.7541 14.1445 11.5598 14.1445C12.3655 14.1445 13.021 14.8 13.021 15.6057C13.021 16.4114 12.3655 17.0669 11.5598 17.0669H11.56Z"
        fill="currentColor"
      />
      <path
        d="M12.9329 15.7441C12.1272 15.7441 11.4717 15.0887 11.4717 14.2829C11.4717 14.2511 11.4727 14.219 11.4747 14.1875L11.5705 14.1937C11.5685 14.2231 11.5676 14.2531 11.5676 14.2829C11.5676 15.0357 12.18 15.6482 12.9329 15.6482C12.9449 15.6482 12.9569 15.6481 12.9689 15.6478L12.9714 15.7437C12.9586 15.744 12.9457 15.7441 12.9327 15.7441H12.9329Z"
        fill="currentColor"
      />
      <path
        d="M11.6564 17.0208L11.5606 17.0141C11.5629 16.9826 11.564 16.9503 11.564 16.9181C11.564 16.1653 10.9516 15.5529 10.1987 15.5529C10.1818 15.5529 10.1666 15.5532 10.1524 15.5538L10.1484 15.4579C10.164 15.4573 10.1803 15.457 10.1987 15.457C11.0044 15.457 11.6599 16.1125 11.6599 16.9182C11.6599 16.9526 11.6586 16.9872 11.6562 17.021L11.6564 17.0208Z"
        fill="currentColor"
      />
      <path
        d="M11.5612 9.70195C10.1731 9.70195 9.04395 8.42298 9.04395 6.85098C9.04395 5.27897 10.1733 4 11.5612 4C12.9492 4 14.0787 5.27897 14.0787 6.85098C14.0787 8.42298 12.9494 9.70195 11.5612 9.70195ZM11.5612 4.47463C10.4348 4.47463 9.51842 5.54064 9.51842 6.85098C9.51842 8.16131 10.4348 9.22732 11.5612 9.22732C12.6877 9.22732 13.6042 8.16131 13.6042 6.85098C13.6042 5.54064 12.6878 4.47463 11.5612 4.47463Z"
        fill="currentColor"
      />
      <path
        d="M11.6725 19.8768H8.51098L8.52239 13.9853L7.16868 15.765L6.79102 15.4777L8.99961 12.5742L8.98652 19.4023H11.6725V19.8768Z"
        fill="currentColor"
      />
      <path
        d="M6.71582 18.2642L5.31141 16.7195C4.78107 16.136 4.71668 15.2708 5.15493 14.6153L6.71445 12.2828C8.03742 10.3357 9.51032 10.4668 9.72861 10.4985H11.9976V10.9729H9.68766L9.66574 10.9688C9.61322 10.9597 8.32451 10.7578 7.1081 12.548L5.54949 14.8791C5.23272 15.353 5.27914 15.9785 5.66259 16.4003L7.067 17.945L6.71597 18.2642H6.71582Z"
        fill="currentColor"
      />
      <path
        d="M14.8353 19.8768H11.6738V19.4023H14.3599L14.3469 12.5742L16.5555 15.4777L16.1778 15.765L14.8241 13.9853L14.8353 19.8768Z"
        fill="currentColor"
      />
      <path
        d="M16.6316 18.2643L16.2805 17.945L17.6849 16.4003C18.0684 15.9785 18.1148 15.353 17.798 14.8791L16.2385 12.5466C15.0112 10.7402 13.6949 10.9662 13.6819 10.9688L13.66 10.9729H11.7891V10.4985H13.6191C13.8374 10.4668 15.3101 10.3357 16.6322 12.2814L18.1928 14.6155C18.631 15.2709 18.5666 16.1362 18.0363 16.7197L16.6319 18.2644L16.6316 18.2643Z"
        fill="currentColor"
      />
      <path
        d="M11.332 14.2206C11.3712 14.1987 11.4187 14.1854 11.4746 14.1854C11.5005 14.1854 11.5244 14.1885 11.5466 14.1935C11.6591 14.1801 11.7722 14.1687 11.8836 14.1638L11.4821 14.0379L10.0548 10.6289L9.61719 10.8122L11.0494 14.2335L11.0414 14.2536C11.1355 14.2454 11.2329 14.2332 11.332 14.2204V14.2206Z"
        fill="currentColor"
      />
      <path
        d="M11.4738 14.1889C11.5254 14.1889 11.5695 14.2002 11.607 14.2191L13.2105 11.9538L12.8232 11.6797L11.1113 14.0979L11.3092 14.2379C11.3523 14.2076 11.4071 14.1889 11.4739 14.1889H11.4738Z"
        fill="currentColor"
      />
      <path
        d="M17.8835 10.1386C16.5251 10.1386 15.4199 8.88517 15.4199 7.34467C15.4199 5.80418 16.5251 4.55078 17.8835 4.55078C19.2419 4.55078 20.3471 5.80418 20.3471 7.34467C20.3471 8.88517 19.2419 10.1386 17.8835 10.1386ZM17.8835 4.96026C16.751 4.96026 15.8296 6.02993 15.8296 7.34467C15.8296 8.65942 16.751 9.72909 17.8835 9.72909C19.016 9.72909 19.9374 8.65942 19.9374 7.34467C19.9374 6.02993 19.016 4.96026 17.8835 4.96026Z"
        fill="currentColor"
      />
      <path
        d="M15.3063 11.3278L15.1348 10.9559C15.5601 10.7597 16.0151 10.6602 16.487 10.6602V11.0698C16.0747 11.0698 15.6774 11.1566 15.3063 11.328V11.3278Z"
        fill="currentColor"
      />
      <path
        d="M22.2294 17.0617H17.751V16.6521H21.8199V13.8911C21.8199 12.3354 20.5543 11.0698 18.9986 11.0698V10.6602C20.7801 10.6602 22.2295 12.1095 22.2295 13.8911V17.0616L22.2294 17.0617Z"
        fill="currentColor"
      />
      <path
        d="M2.67578 6.85249C2.67578 5.31184 3.78092 4.05859 5.13935 4.05859C6.49779 4.05859 7.60292 5.31199 7.60292 6.85249C7.60292 8.39298 6.49779 9.64638 5.13935 9.64638C3.79081 9.64638 2.67578 8.39298 2.67578 6.85249ZM3.08526 6.85249C3.08526 8.16723 4.00666 9.2369 5.1392 9.2369C6.27173 9.2369 7.19314 8.16723 7.19314 6.85249C7.19314 5.53774 6.27173 4.46807 5.1392 4.46807C4.00666 4.46807 3.08526 5.53774 3.08526 6.85249Z"
        fill="currentColor"
      />
      <path
        d="M1.00015 16.6398H5.47854V16.2302H1.40963V13.4692C1.40963 11.9135 2.67521 10.6479 4.23092 10.6479V10.2383C2.44946 10.2383 1 11.6876 1 13.4692V16.6397L1.00015 16.6398Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default Clubsicon;
